// extracted by mini-css-extract-plugin
export default {"item":"footer_item-module__item--1XtXL"};